var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoultryWeights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 224.176,
    height: 111.585,
    viewBox: "0 0 224.176 111.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4582",
    "data-name": "Rectangle 4582",
    width: 224.176,
    height: 111.585,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9162",
    "data-name": "Group 9162",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9973",
    "data-name": "Path 9973",
    d: "M224.055,10.068a11.235,11.235,0,0,0-9.327,4.96c-26.6-7.806-48.611-8.408-77.179-7.321a11.255,11.255,0,0,0-21.7,1.262C83.228,12.225,56.026,22.98,19.893,38.431L22.319,44.1C57.846,28.912,84.578,18.333,116.3,15.128a11.255,11.255,0,0,0,21.513-1.256c27.844-1.055,49.312-.47,75.006,7.03,0,.137-.011.274-.011.412a11.247,11.247,0,1,0,11.247-11.247",
    transform: "translate(-11.126)",
    fill: "#022641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9974",
    "data-name": "Path 9974",
    d: "M225.907,75.372a11.056,11.056,0,0,0-3.713.64,124.191,124.191,0,0,0-29.352-27.988c-16.032-10.73-34.482-16.848-54.949-18.242a9.862,9.862,0,0,0-18.227-.29c-26.82.185-45.05,2.078-96.462,21.486l2.178,5.772c49.977-18.865,67.947-20.869,93.74-21.082a9.861,9.861,0,0,0,19.116.315c32.089,2.33,58.06,16.69,78.943,43.648a11.074,11.074,0,1,0,8.726-4.258",
    transform: "translate(-12.978 -13.166)",
    fill: "#ffdfb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9975",
    "data-name": "Path 9975",
    d: "M175.769,104.179a15.98,15.98,0,0,0-5.123.843,146.99,146.99,0,0,0-19.863-25.791,126.636,126.636,0,0,0-32.844-24,9.861,9.861,0,0,0-17.681-7.252C72.877,40.753,40.1,50.364,19.779,58.369a11.339,11.339,0,1,0,2.683,5.57c19.492-7.649,50.41-16.692,75.852-10.1v.023a9.86,9.86,0,0,0,16.906,6.9c23.641,12.224,38.186,28.024,50.1,47.309a16,16,0,1,0,10.451-3.888",
    transform: "translate(0 -24.608)",
    fill: "#022641"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoultryWeights);
export default __webpack_public_path__ + "static/media/PoultryWeights.aafa8771685beb10ae46d0f5e9e840f6.svg";
export { ForwardRef as ReactComponent };